import { CONTINUOUS_BLOCK } from '../../../types/BlockTypes';

function filterInvalideNodes(node) {
  return !!CONTINUOUS_BLOCK[node.type];
}

export default function shouldWrapOrphanBlocks(node, editor, next) {
  if (node.object !== 'document') return next();
  var nodesToNormalize = editor.value.document.nodes.filter(filterInvalideNodes);
  nodesToNormalize.forEach(function (child) {
    editor.wrapBlockByKey(child.key, CONTINUOUS_BLOCK[child.type]);
  });
  return next();
}